// extracted by mini-css-extract-plugin
export default {"message":"message--38726e2","informations":"informations--d2290a5"};